const TOKEN_KEY = 'aerosuggest_token';
const USERNAME_KEY = 'aerosuggest_username';
const LEGACY_USER_ID_KEY = 'userId';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUsername() {
  return localStorage.getItem(USERNAME_KEY);
}

export function saveAuth(token, username) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USERNAME_KEY, username);
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USERNAME_KEY);
}

export function isAuthenticated() {
  return !!getToken();
}

// Backward-compat: anonymous user ID used for voting before auth existed
export function getAnonymousId() {
  let id = localStorage.getItem(LEGACY_USER_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(LEGACY_USER_ID_KEY, id);
  }
  return id;
}

// Returns headers object for API calls
export function authHeaders() {
  const token = getToken();
  if (token) return { 'X-Auth-Token': token };
  return { 'X-User-Id': getAnonymousId() };
}
